import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { IProject, Scene } from '@d-id/types';
import { AxiosRequestHeaders } from 'axios';

export const getProject = async (id: string): Promise<IProject> => {
    const response = await authenticatedAxios.get<IProject>(`${didApiUrl}/projects/${id}`);
    return response?.data;
};

export const deleteManyProjects = async (ids: string[]) => {
    const searchParams = new URLSearchParams(ids.map(id => ['ids', id]));
    const response = await authenticatedAxios.delete(`${didApiUrl}/projects/bulk?${searchParams}`);

    return response.data;
};

export const createProject = async (name: string): Promise<IProject> => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/projects`, { name });
    return response?.data;
};

export const duplicateProject = async (id: string): Promise<string> => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/projects/clone`, { id });
    return response?.data;
};

export const generateProject = async (
    id: string,
    scenes?: Scene[],
    renderer?: string,
    removeLogo?: boolean,
    headers?: AxiosRequestHeaders,
    estimated_duration?: number
) => {
    const body = { id, renderer, scenes, estimated_duration, ...(removeLogo && { user_data: JSON.stringify({ no_logo: true }) }) };

    const response = await authenticatedAxios?.post(`${didApiUrl}/projects/generate`, body, { headers });
    return response?.data;
};
